import React from 'react';
import { createPortal } from 'react-dom';

export interface ResultModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  actionLabel?: string;
}

/**
 * Reusable modal for quiz results, achievements, and similar overlays.
 * Aligns with design system: overlay, card-style content, primary button.
 */
const ResultModal: React.FC<ResultModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  actionLabel = 'Continue',
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="result-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="result-modal-title"
    >
      <div
        className="result-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="result-modal-title" className="result-modal__title">
          {title}
        </h2>
        <div className="result-modal__body">
          {children}
        </div>
        <div className="result-modal__actions">
          <button
            type="button"
            className="btn btn-primary result-modal__button"
            onClick={onClose}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ResultModal;
